import { render, staticRenderFns } from "./mdAccessDenied.vue?vue&type=template&id=a4c2c0d0&scoped=true&"
import script from "./mdAccessDenied.vue?vue&type=script&lang=js&"
export * from "./mdAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c2c0d0",
  null
  
)

export default component.exports